module.exports = {
    init: function()
    {
        var tabSystems = document.querySelectorAll(".tab-system");

        Array.from(tabSystems).forEach(tabSystem => {

            let tabsArea = tabSystem.querySelector(".tab-system-tabs");
            tabsArea.addEventListener("scroll", function(evt) {
                if(tabsArea.scrollLeft > 15) {
                    tabSystem.querySelector(".tab-system-tabs-gradient-left").style.display = "";
                } else {
                    tabSystem.querySelector(".tab-system-tabs-gradient-left").style.display = "none";
                }
            })
        });

        function setup() {
            Array.from(tabSystems).forEach(tabSystem => {


                tabSystem.querySelector(".tab-system-tabs-gradient-left").style.display = "none";

                if(tabSystem.querySelector(".tab-system-tabs").scrollWidth <= window.innerWidth) {
                    tabSystem.querySelector(".tab-system-tabs-gradient:not(.tab-system-tabs-gradient-left)").style.display = "none";
                }
            });
        }

        setup();

        window.addEventListener("resize", setup);

    }
}